import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'flash-messages-angular';
import { IOnInitCallbackActions, IPayPalConfig } from 'ngx-paypal';
import { GlobalErrorsHandler } from 'src/app/core/errors/global-errors.handler';
import { Order } from 'src/app/models';
import { PaypalService } from 'src/app/services/paypal.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sign-up4',
  templateUrl: './sign-up4.component.html',
  styleUrls: ['./sign-up4.component.css']
})
export class SignUp4Component implements OnInit {

  payPalConfig!: IPayPalConfig;
  payPalActions?: IOnInitCallbackActions;
  payPalOrder?: Order;

  submitting = false;

  constructor(private userService: UserService, private router: Router, private paypalService: PaypalService, private flashMessage: FlashMessagesService, private errorsHandler: GlobalErrorsHandler) { }

  ngOnInit(): void {
    if (!this.userService.user.signup) {
      this.router.navigate(['/sign-up']);
      return;
    }

    this.initPaypal();
  }

  private initPaypal() {
    this.payPalConfig = {
      clientId: environment.paypal.clientId,
      advanced: {
        extraQueryParams: [{ name: 'disable-funding', value: 'paylater' }],
      },
      onInit: (data, actions) => {
        this.payPalActions = actions;
      },
      createOrderOnServer: (data) => this.paypalCallback(async () => {
        const user = this.userService.user;
        const order = await this.paypalService.createOrder('Signup', user, data).toPromise();
        this.payPalOrder = order;
        return order.paymentID;
      }),
      authorizeOnServer: (data) => this.paypalCallback(async () => {
        const user = this.userService.user;
        const orderID = this.payPalOrder!._id;
        await this.paypalService.completeOrder(orderID, user, data).toPromise();
        await this.userService.register(user, '', orderID);
      }),
      onError: err => {
        console.log('PayPal error:', err);
        this.errorsHandler.handleError(err);
      }
    };
  }

  private async paypalCallback(callback: () => Promise<any>) {
    this.submitting = true;

    try {
      this.payPalActions?.disable();

      return await callback();
    }
    catch (err) {
      this.errorsHandler.handleError(err);
      throw err;
    }
    finally {
      this.submitting = false;

      this.payPalActions?.enable();
    }
  }
}
